import { ChangePasswordScreen } from "@/features/auth";

export default ChangePasswordScreen;
